<template>
  <v-card flat>
    <v-card-title>
      <span class="subtitle-1">Peer Reviewers</span>
      <v-spacer />
      <v-btn
        small
        color="primary"
        outlined
        @click="addPeerDialog = true"
      >
        <v-icon left>mdi-account-plus</v-icon>
        Add Peer
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list dense>
        <v-list-item v-for="peer in appraisalPeers" :key="peer.peerNo">
          <v-list-item-avatar>
            <v-icon color="primary">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ peer.peerName || getEmployeeName(peer.peerNo) }}</v-list-item-title>
            <v-list-item-subtitle>{{ peer.peerNo }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="appraisalPeers.length === 0">
          <v-list-item-content>
            <v-list-item-subtitle>No peer reviewers added yet.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-dialog v-model="addPeerDialog" max-width="500px">
      <v-card>
        <v-card-title>Add Peer Reviewer</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedEmployee"
            :items="employees"
            item-text="full_name"
            item-value="number"
            label="Select Employee"
            outlined
            dense
            return-object
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="addPeerDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="handleAddPeer" :disabled="!selectedEmployee" :loading="addingPeer">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "PeerSelection",
  props: {
    reviewID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    addPeerDialog: false,
    selectedEmployee: null,
    addingPeer: false,
  }),
  computed: {
    appraisalPeers() {
      return this.$store.getters["appraisal/appraisalGetter"]("appraisalPeers") || [];
    },
    allEmployees() {
      return this.$store.getters["Setup/setupGetter"]("leaveEmployees") || [];
    },
    employees() {
      return this.allEmployees.map((emp) => ({
        ...emp,
        full_name: `${emp.first_name} ${emp.last_name} (${emp.number})`,
      }));
    },
  },
  methods: {
    getEmployeeName(number) {
      const emp = this.allEmployees.find((e) => e.number === number);
      return emp ? `${emp.first_name} ${emp.last_name}` : number;
    },
    async handleAddPeer() {
      if (this.selectedEmployee) {
        try {
          await this.$store.dispatch("appraisal/addPeer", {
            documentNo: this.reviewID,
            peerNo: this.selectedEmployee.number,
          });

          // 👇 THIS was missing
          await this.$store.dispatch(
            "appraisal/getAppraisalPeers",
            this.reviewID
          );

          this.addPeerDialog = false;
          this.selectedEmployee = null;
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("appraisal/getAppraisalPeers", this.reviewID);
    if (this.allEmployees.length === 0) {
      this.$store.dispatch("Setup/getLeaveEmployees");
    }
  },
};
</script>
